import { createCustomerTheme } from "@coast/components"
import { coastlineExtension } from "@coast/utils"

const theme = createCustomerTheme(coastlineExtension)

export default theme
